import Vue from 'vue';
import Vuex from 'vuex';
import * as GmapVue from 'gmap-vue'
import SmallSlider from '../vue/SmallSlider.vue';
import TextSlider from '../vue/TextSlider.vue';
import BigSlider from '../vue/BigSlider.vue';
import ImageSlider from '../vue/ImageSlider.vue';
import VideoModal from '../vue/VideoModal.vue';
import BigText from '../vue/BigText.vue';
import LearnMore from '../vue/LearnMore.vue';
import SingleImage from '../vue/SingleImage.vue';
import SingleContactImage from '../vue/SingleContactImage.vue';
import SiteFooter from '../vue/SiteFooter.vue';
import SiteHeader from '../vue/SiteHeader.vue';
import SingleHeader from '../vue/SingleHeader.vue';
import ProjectDetails from '../vue/ProjectDetails.vue';
import PostShare from '../vue/PostShare.vue';
import NewsListing from '../vue/NewsListing.vue';
import HomeListing from '../vue/HomeListing.vue';
import CtaListing from '../vue/CtaListing.vue';
import TeamListing from '../vue/TeamListing.vue';
import GoogleMap from '../vue/GoogleMap.vue';
import CareersList from '../vue/CareersList.vue';
import SmartSlider from '../vue/SmartSlider.vue';
import PrimaryButton from '../vue/PrimaryButton.vue';
import HeroCta from '../vue/HeroCta.vue';
import AccordionList from '../vue/AccordionList.vue';

Vue.use(Vuex);

Vue.use(GmapVue, {
  load: {
    key: 'AIzaSyBvBUEC0g_ZKO91GenI4B7XP-xkI9nNIvk',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,
})

export default {
  init() {
    /* Vue
    ---------------------------------------------------------------------------------------------------- */

    Vue.config.productionTip = false;

    const store = new Vuex.Store({
      state: {
        headerHeight: null,
      },
      getters: {},
      mutations: {
        updateHeaderHeight(state, payload) {
          state.headerHeight = payload;
        },
      },
      actions: {},
      plugins: [],
    });

    new Vue({
      store: store,
      data: {
        topScrollThreshold: 1,
        isScrolled: false,
        headerHeight: 150,
      },

      components: {
        SmallSlider,
        TextSlider,
        BigSlider,
        ImageSlider,
        VideoModal,
        BigText,
        LearnMore,
        SingleImage,
        SiteFooter,
        SiteHeader,
        SingleHeader,
        ProjectDetails,
        PostShare,
        NewsListing,
        HomeListing,
        CtaListing,
        TeamListing,
        GoogleMap,
        CareersList,
        SmartSlider,
        SingleContactImage,
        PrimaryButton,
        HeroCta,
        AccordionList,
      },

      methods: {
        didScroll() {
          this.isScrolled = window.scrollY > this.topScrollThreshold;
        },
      },

      created() {
        window.addEventListener('scroll', this.didScroll);
      },

      destroyed() {
        window.removeEventListener('scroll', this.didScroll);
      },

      mounted() {
      },
    }).$mount('#app');
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js